import React from "react"

const CommonIndustries = ({ data }) => {
  return (
    <section
      id="industries"
      className=" grid  items-center gap-[3rem] md:gap-[5.5rem]  grid-cols-1  py-16 md:py-[6.75rem] "
    >
      <div
        className={`flex justify-end z-[2]    md:flex-col px-6 md:px-20  gap-6 items-start `}
      >
        <div className="flex  flex-col items-end gap-6 w-full">
          <div className="flex items-center gap-2">
            <div className="bg-blue-100 w-2 h-2 rounded-full"></div>
            <div className="flex gap-3 tracking-tight-4% ">
              <h4 className={`text-gray-500  text-lg lg:text-2xl `}>
                {data.section}
              </h4>
            </div>
          </div>
          <h2
            className={`text-gray-100 text-[3.7rem] md:text-7xl  lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7% `}
          >
            {data.label}
          </h2>
        </div>
      </div>
      <div
        className={`grid ps-6  grid-rows-2 custom-scrollbar md:grid-cols-4 md:grid-flow-row grid-flow-col md:grid-rows-none overflow-auto md:overflow-visible gap-x-4 md:gap-x-6 gap-y-8 md:gap-y-10 px-0 md:px-20`}
      >
        {data.technologies.map((tech, index) => (
          <div
            className={`min-w-[144px] text-center rounded-[99px]  px-5 lg:p-10 min-h-[48px] md:min-h-[120px] tex-black-300  bg-white-200 flex flex-col md:flex-row  gap-[1.3rem] md:gap-4`}
            key={index}
          >
            <div
              className={`flex basis-full justify-center  items-center gap-4`}
            >
              <span className="text-gray-100  text-sm  lg:text-2xl -tracking-[0.32px] lg:tracking-tight-4%">
                {tech.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default CommonIndustries
